module.exports = __webpack_public_path__ + "img/purple1.fbcbebbf.jpg";